module.exports = __webpack_public_path__ + "static/img/catalog_settings_tree.92af0748.png";